var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.otcsBuy[0])?_c('PowerOtcTable',{attrs:{"is-buying":true,"otcs":_vm.otcsBuy}}):_vm._e(),_vm._v(" "),(_vm.otcsSell[0])?_c('PowerOtcTable',{attrs:{"is-buying":false,"otcs":_vm.otcsSell}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }